/* eslint-disable i18next/no-literal-string */
import { Fragment } from 'react';

export const vgStaff = [
  {
    staffPosition: 'Ansvarlig redaktør',
    staffName: 'Gard Steiro',
  },
  { staffPosition: 'Målgrupperedaktør', staffName: 'Beate Amundsen Koren' },
  { staffPosition: 'Utviklingsredaktør', staffName: 'Øyvind Brenne' },
  { staffPosition: 'Politisk redaktør', staffName: 'Frøy Gudbrandsen' },
  { staffPosition: 'Tilsynsorgan', staffName: 'Medietilsynet' },
];

export const abStaff = [
  {
    staffPosition: 'Tipsa oss',
    staffName: (
      <Fragment>
        SMS: 71 000. Meil:{' '}
        <a href="mailto:tipsa@aftonbladet.se">tipsa@aftonbladet.se</a>
      </Fragment>
    ),
  },
  {
    staffPosition: 'Chefredaktör, vd och ansvarig utgivare',
    staffName: 'Lotta Folcker',
  },
  {
    staffPosition: 'Stf ansvarig utgivare',
    staffName: 'Martin Schori',
  },
  {
    staffPosition: 'redaktionschef',
    staffName: 'Karin Schmidt',
  },
];

export const vgLinks = [
  {
    href: 'http://www.vg.no/informasjon/privacy/',
    text: 'Personvernerklæring og informasjonskapsler (cookies)',
  },
];

export const abLinks = [
  {
    href: 'https://www.aftonbladet.se/hjalpinfo/vanligafragor/article23620164.ab',
    text: 'Användarvillkor',
  },
  {
    href: 'https://info.privacy.schibsted.com/se/schibsted-sverige-personuppgiftspolicy/',
    text: 'Personuppgiftspolicy',
  },
  {
    href: 'https://info.privacy.schibsted.com/se/schibsted-sverige-personuppgiftspolicy/',
    text: 'Cookiepolicy',
  },
  {
    href: 'https://www.aftonbladet.se/a/Xw1dVB/rapportera-fel-i-aftonbladet',
    text: 'Rapportera fel',
  },
  {
    href: 'https://www.aftonbladet.se/minsida/nyhetsbrev',
    text: 'Nyhetsbrev',
  },
];
